import React, { useEffect, useState } from 'react'
import BoxedTruck12Ton2Axles from '../../../../../shared/common-utilities/Truck/BoxedTruck12Ton2Axles.jsx';
import EuropeanTruck from '../../../../../shared/common-utilities/Truck/EuropeanTruck.jsx';
import FlatbedTruck from './../../../../../shared/common-utilities/Truck/FlatbedTruck';
import CommentIcon from '@mui/icons-material/Comment';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import BoxedTruck18Ton3Axles from './../../../../../shared/common-utilities/Truck/BoxedTruck18Ton3Axles';
import Tractor2Axles from './../../../../../shared/common-utilities/Truck/Tractor2Axles';
import DryVan from './../../../../../shared/common-utilities/Trailer/DryVan';
import Van from './../../../../../shared/common-utilities/Truck/Van';

export const TruckResource = (props) => {
    const { resource, handleEventHoverIn, handleEventHoverOut, toggleOpenMail,openMail,handleDragStart,nvtVehicleType } = props
    const [vehicle,setVehicle] = useState({})
    useEffect(()=>{        
        if(resource?.vehicles?.length >0){
            let veh = resource.vehicles[0]
            veh.vehicleTypeEnum2 = nvtVehicleType?.find(e => e.name == vehicle.vehicleTypeEnum)            
            setVehicle(veh)
        }
        
    },[resource])
    const getTruckTypeIcon = ()=>{
        if(vehicle.vehicleTypeEnum == "BT12")
            return <BoxedTruck12Ton2Axles height="25" />
        else if(vehicle.vehicleTypeEnum == "BT18")
            return <BoxedTruck18Ton3Axles height="25" />
        else if(vehicle.vehicleTypeEnum == "TRAC")
            return <Tractor2Axles height="25" />
        else if(vehicle.vehicleTypeEnum == "VAN")
            return <Van height="25" />
        else
            return <FlatbedTruck height="25" />
    }
    
    return (
        <>
            <div className='d-flex cursor-pointer relative align-items-center vh-text'>
                
                <span onMouseEnter={e => handleEventHoverIn(e, "TruckHover", resource)} onMouseLeave={handleEventHoverOut}>    
                <div className='vh-number'>
                    {resource.resourceNo}
                </div>                
                    <span style={{pointerEvents:'none'}}>{getTruckTypeIcon()}</span>
                </span>
            </div>
            <div className='mt0'>
                <div 
                // onMouseEnter={e => handleEventHoverIn(e, "LicenseHover", resource)} onMouseLeave={handleEventHoverOut}
                >
                    {/* <Tooltip width="600" title={countryCode?.toUpperCase()}> */}
                        <span className={'number-plate sm ' + (vehicle?.countryRegion?.toLowerCase() || 'nl')} draggable onDragStart={e => handleDragStart(e, "Resource",resource)}>
                            {vehicle?.numberplate}
                        </span>
                    {/* </Tooltip> */}
                </div>
                <div style={{ margin: "0 5px", display: 'flex', gap: 3, alignItems: 'center' }} >                    
                    {/* <i className="icon" style={{ height: '20px' }} >
                        {openMail.resource == resource.name && openMail.isOpened ? <CommentIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: false })} /> : <MarkUnreadChatAltIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: true })} />}
                    </i> */}
                    {/* <WarningIcon color='warning' fontSize="small" /> */}
                </div>
            </div>
        </>
    )
}
